import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../../PermissionSetTypes'
import { PermissionType } from '../../PermissionType'
import { DefaultSuperAdminPermissionSet, defaultSuperAdminPermissionSetGrouping } from './DefaultSuperAdminPermissions'
import { SuperAdminOrganizationPermissions, SuperAdminPermissions } from './SuperAdminPermissions'

export enum RootSuperAdminPermissionSet {
  RootSuperAdmin = 'super_admin_root_admin',
}

export const rootSuperAdminPermissionSetGrouping: IPermissionSetGrouping<RootSuperAdminPermissionSet> = {
  key: PermissionSetGroupingKey.SuperAdminRoot,
  active: {
    [RootSuperAdminPermissionSet.RootSuperAdmin]: [
      ...defaultSuperAdminPermissionSetGrouping.active[DefaultSuperAdminPermissionSet.DefaultSuperAdmin],
      ...SuperAdminOrganizationPermissions.manageAny,
      ...SuperAdminPermissions.manage,
      PermissionType.DELETE_ANY_ORGANIZATION_EAM_DATA,
      PermissionType.DELETE_ORGANIZATION_RIDERS,
      PermissionType.PATCH_ANY_ORGANIZATION_NOTIFICATION_PROVIDERS,
      PermissionType.POST_SPARE_MOBILE_APP_ORGANIZATION,
      PermissionType.GET_NOTIFICATION_RESTRICTIONS,
      PermissionType.PUT_NOTIFICATION_RESTRICTIONS,
      PermissionType.ENABLE_RESTRICTED_FEATURE_FLAGS,
    ],
  },
  unAssignablePermissionSets: [RootSuperAdminPermissionSet.RootSuperAdmin],
  isSuperAdminSet: true,
}
